import React from "react";
import { Typography, Box, Rating } from "@mui/material";
import { toSlug } from "../../../../_utils/toSlug";
import { styled } from "@mui/material/styles";
import CourseCardTitle from "./CourseCardTitle";
import CourseCardInstructor from "./CourseCardInstructor";

const CustomRating = styled(Rating)(({ customfontsize }) => ({
  fontSize: `${customfontsize}px`,
  "& .MuiRating-icon, & .MuiRating-iconEmpty": {
    fontSize: `${customfontsize}px`,
  },
}));
// Define a styled Typography component
const StyledLink = styled(Typography)(({ theme, customfontsize }) => ({
  display: "block", // inline for typography

  fontSize: `${0.7 * customfontsize}px`,
  color: theme.palette.grey[700],
  lineHeight: `${customfontsize}px`,
  overflow: "hidden", // Hide overflowed text
  textOverflow: "ellipsis", // Show ellipsis for overflowed text
  whiteSpace: "nowrap", // Prevent wrapping to a new line
  textDecoration: "none", // Remove text decoration like underline
  textTransform: "capitalize", // Capitalize the first letter of each word
  paddingTop: `${0.2 * customfontsize}px`,
  paddingRight: `${0.2 * customfontsize}px`,
  paddingBottom: `${0.2 * customfontsize}px`,
  paddingLeft: `0px`,

  // Add hover effect for the span element
  "& span": {
    borderRadius: "10px",
    backgroundColor: theme.palette.grey[200],
    padding: `${0.2 * customfontsize}px ${0.8 * customfontsize}px`,
    transition: "background-color 0.3s, transform 0.3s ease-in-out", // Smooth transitions for hover effect
    animation: "scaleUp 0.3s ease-in-out", // Animation for scale on hover
  },

  // Span hover effect: change background and color, animate scale
  "& span:hover": {
    backgroundColor: theme.palette.primary.main, // Change background color on hover
    color: theme.palette.grey[100], // Change text color on hover
    transform: "scale(1.1)", // Slightly enlarge the span when hovered
    animation: "scaleUp 0.3s ease-in-out", // Optional: ensures animation persists during hover
  },

  // Keyframes for scaling effect
  "@keyframes scaleUp": {
    "0%": {
      transform: "scale(1)", // Initial scale
    },
    "100%": {
      transform: "scale(1.1)", // Scale up slightly on hover
    },
  },

  // Hover effect styling for the Typography component itself
  "&:hover": {
    cursor: "pointer", // Add pointer cursor when hovering over the link
  },
}));

const CourseCardContent = ({
  courseTitle,
  courseCategory,
  rating,
  instructorHref,
  instructorName,
  customfontsize
}) => {

  const ratingStyle = {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between",

    flexWrap: "wrap",
  };

  return (
    <Box
      component="ul"
      sx={{
        listStyle: "none",
        p: 0,
        m: 0,
        display: "flex",
        width: "100%",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Typography component="li">
        <CourseCardTitle courseTitle={courseTitle} />
      </Typography>
      <Typography component="li" sx={{}}>
        <StyledLink
          component="a"
          href={`/category/${toSlug(courseCategory)}`}
          customfontsize={customfontsize}
        >
          <span> {courseCategory}</span>
        </StyledLink>
      </Typography>

      <Typography component="li" sx={ratingStyle}>
        <CustomRating
          value={rating}
          precision={0.5}
          readOnly
          aria-label={`${rating} star rating`}
          customfontsize={customfontsize}
        />
        <Typography
          component="span"
          style={{ marginLeft: "auto", fontSize: `${customfontsize}px` }}
        >
          ({rating} Reviews)
        </Typography>
      </Typography>
      <Typography component="li">
        <CourseCardInstructor
          instructorHref={instructorHref}
          instructorName={instructorName}
        />
      </Typography>
    </Box>
  );
};

export default CourseCardContent;
